import { render, staticRenderFns } from "./SideBarProfile.vue?vue&type=template&id=358f1bab&scoped=true&"
import script from "./SideBarProfile.vue?vue&type=script&lang=js&"
export * from "./SideBarProfile.vue?vue&type=script&lang=js&"
import style0 from "./SideBarProfile.vue?vue&type=style&index=0&id=358f1bab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f1bab",
  null
  
)

export default component.exports